import { AppNotifications } from "../common/AppNotification";
import { ProfileModal } from "../features/Modals/ProfileModal";
import { initMultiUserStorage } from "../shared/utils/multiUserFunctions";
import { AppProvider } from "./providers";
import { AppRouting } from "./routing";

export const App = () => {
  initMultiUserStorage();

  return (
    <AppProvider>
      <AppNotifications />
      <ProfileModal />
      <AppRouting />
    </AppProvider>
  );
};
